import { Divider } from '@mui/material';
import styled from 'styled-components';
import { Icon } from '../../atoms';
import { BorderType } from './Header';

export const StyledHeaderContainer = styled.div<{ borderType: BorderType }>`
  grid-area: header;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme: { color, palette } }) =>
    palette.mode === 'dark' ? color.backgroundDark : color.white};
  border-bottom: ${({ theme: { color }, borderType }) => `1px ${borderType} ${color.borderGray}`};
`;

export const StyledHeaderMenu = styled.div`
  display: flex;
  margin-left: auto;
  align-items: center;
  > div,
  button {
    :last-child {
      margin-right: 0;
    }
  }
`;

export const LanguageItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  > :first-of-type {
    margin-right: ${({ theme }) => theme.spacing(4)};
  }
`;

export const StyledIcon = styled(Icon)`
  width: auto;
`;
export const StyledDivider = styled(Divider)`
  height: ${({ theme: { spacing } }) => spacing(6)};
  margin: ${({ theme: { spacing } }) => spacing(0, 2)};
  background-color: ${({ theme: { color, palette } }) => palette.mode === 'dark' && color.borderGrayDark};
`;
